<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <unit-cost />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <unit-sale />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <taxes-select />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <currencies-select />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <quantity-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <units-select />
        </b-col>
        <b-col cols="12">
          <notes-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import UnitCost from '@/views/Services/Prices/Elements/UnitCost.vue'
import UnitSale from '@/views/Services/Prices/Elements/UnitSale.vue'
import TaxesSelect from '@/views/Services/Prices/Elements/TaxesSelect.vue'
import CurrenciesSelect from '@/views/Services/Prices/Elements/CurrenciesSelect.vue'
import QuantityCard from '@/views/Services/Prices/Elements/QuantityCard.vue'
import UnitsSelect from '@/views/Services/Prices/Elements/UnitsSelect.vue'
import NotesCard from '@/views/Services/Prices/Elements/NotesCard.vue'

export default {
  name: 'ServicesPricesItemForm',
  components: {
    UnitCost,
    UnitSale,
    TaxesSelect,
    QuantityCard,
    UnitsSelect,
    NotesCard,
    CurrenciesSelect,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['servicePrices/dataItem']
    },
  },
}
</script>
